import { Link } from "react-router-dom";
import AlertComponent from "../../components/atoms/alert/alert.component";

const FooterTemplate = ({ templateData, templateEvent }) => {
  const { settings, alert } = templateData;
  const { handleSubscribe, setEmail, email, handleAlertClose } = templateEvent;

  const social = {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
  };

  return (
    <footer id="footer" className="ds-footer">
      {/* Newsletter */}
      <div className="ds-newsletter">
        <div className="ds-container ds-newsletter-inner">
          <div>
            <h3>Get the latest news</h3>
            <p>New parts, price drops and sourcing tips — straight to your inbox.</p>
          </div>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleSubscribe();
            }}
          >
            <input
              type="email"
              name="email"
              placeholder="you@company.com"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button type="submit" className="ds-btn ds-btn-primary" onClick={() => handleSubscribe()}>
              Subscribe
            </button>
          </form>
          {alert.show && (
            <div style={{ flexBasis: "100%" }}>
              <AlertComponent
                type={alert.type}
                message={alert.message}
                onClose={handleAlertClose}
              />
            </div>
          )}
        </div>
      </div>

      {/* Link columns */}
      <div className="ds-container">
        <div className="ds-footer-cols">
          <div className="ds-footer-brand">
            <a href="/" className="ds-logo" style={{ display: "inline-block", marginBottom: 16 }}>
              <img
                src={settings?.footer_logo}
                alt="footer logo"
                style={{ maxHeight: 60, width: "auto" }}
              />
            </a>
            <p>{settings?.footer_description}</p>
          </div>

          <div className="ds-footer-col">
            <h5>Company</h5>
            <ul>
              <li><Link to={"/about-us"}>About Us</Link></li>
              <li><a href="#">Corporate Social Responsibility</a></li>
              <li><a href="#">Quality</a></li>
            </ul>
          </div>

          <div className="ds-footer-col">
            <h5>Resources</h5>
            <ul>
              <li><a href="#">Blog</a></li>
              <li><Link to={"/product-list"}>Newest Products</Link></li>
              <li><a href="#">New Manufacturers</a></li>
              <li><a href="#">Services &amp; Tools</a></li>
            </ul>
          </div>

          <div className="ds-footer-col">
            <h5>Support</h5>
            <ul>
              <li><Link to={"/contact-us"}>Contact Us</Link></li>
              <li><a href="#">Help</a></li>
            </ul>
          </div>

          <div className="ds-footer-col">
            <h5>Consumer Policy</h5>
            <ul>
              <li><Link to={"/page/privacy-policy"}>Privacy Policy</Link></li>
              <li><Link to={"/page/return-policy"}>Return Policy</Link></li>
              <li><Link to={"/page/terms-and-conditions"}>Terms &amp; Conditions</Link></li>
            </ul>
          </div>
        </div>

        {/* {settings?.footer_customer_service && (
          <div className="ds-footer-col" style={{ paddingBottom: 24 }}>
            <h5>Customer Service Office</h5>
            <p style={{ color: "rgba(255,255,255,.6)", maxWidth: "40ch" }}>
              {settings?.footer_customer_service}
            </p>
          </div>
        )} */}
      </div>

      {/* Bottom bar */}
      <div className="ds-footer-bottom">
        <div className="ds-container ds-footer-bottom-inner">
          <span className="legal">© 2026 semi search 360. All rights reserved.</span>
          <div className="ds-socials">
            <a href="#" aria-label="Instagram">
              <svg width="18" height="18" viewBox="0 0 24 24" {...social}>
                <rect x="2" y="2" width="20" height="20" rx="5" />
                <circle cx="12" cy="12" r="4" />
                <line x1="17.5" y1="6.5" x2="17.5" y2="6.5" />
              </svg>
            </a>
            <a href="#" aria-label="Facebook">
              <svg width="18" height="18" viewBox="0 0 24 24" {...social}>
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
              </svg>
            </a>
            <a href="#" aria-label="YouTube">
              <svg width="18" height="18" viewBox="0 0 24 24" {...social}>
                <path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z" />
                <polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default FooterTemplate;
